<script>
const plantilla =
  `
<div style="tex-align:justify;font-family:Calibri,Ubuntu,Verdana;">
<p style="text-align:center">
<img src="https://app.babelinvestment.com/babel2.png" style="width:200px;text-align:center;" />
</p>
<h1 style="text-align:center;">XXtituloXX</h1>
<div style="width:50%;min-width:320px;display:block;margin-left:auto;margin-right:auto;">
<p style="font-family:Calibri,Ubuntu,Verdana;text-align:justify;">
XXcuerpo1XX
</p>
<p style="font-family:Calibri,Ubuntu,Verdana;text-align:justify;">
XXcuerpo2XX
</p>
<br />
</div>
</div>
`
let parametrosRequeridos = ['destino', 'cuerpo1', 'cuerpo2', 'titulo']
let emailOrigen = 'cmms@tecnhos.com.mx'
let nombreOrigen = 'Robot CMMS'
const mailChimpAkiKey = '7186d1c1da7bd9783d8f24f69c4362cc-us20'
const mailChimpLista = '66fe635a83'
import axios from 'axios'
import Vue from 'vue'
import Api from '@/components/Api/Api'

let Emailer = new Vue({
  name: 'Emailer',
  data() {
    return {
      prueba: Api.modoPruebas
    }
  },
  methods: {
    registrarMailChimp: function(usuario) {
      usuario = usuario || {}
      console.log("Registrando", usuario.rol, usuario.nombre, usuario.email)
      let dc = mailChimpAkiKey.split('-')[1]
      let url = 'https://' + dc + '.api.mailchimp.com/3.0/'
      //
      url += 'Lists'
      axios.get(url, {}, {
        headers: {
          Authorization: 'apikey ' + mailChimpAkiKey
        }
      }).then(o => {
        console.log("MC!", o)
      }).catch(e => {
        console.error("Error MC", e)
      })
    },
    enviar: function(params) {
      let vm = this
      let prueba = !Api.modoProduccion
      if (prueba && false)
        return new Promise(resolve => {
          resolve(true)
        })
      else
        return new Promise(async (resolve, reject) => {
          let cumpleParametros = true
          parametrosRequeridos.forEach(param => {
            if (!params[param])
              cumpleParametros = false
          })
          if (typeof params != 'object')
            reject({
              error: 'Debo recibir un objeto con parámetros'
            })
          else if (!cumpleParametros)
            reject({
              error: 'Debes incluir todos los parámetros',
              parametros: parametrosRequeridos
            })
          else {
            let mensaje = '' + plantilla
            for (let i of parametrosRequeridos)
              if (i != 'attachments')
                mensaje = mensaje.replace('XX' + i + 'XX', params[i])
            let mailconfig = params.mailconfig //|| null
            if (!mailconfig) {
              let empresa = (await Api.get('empresa'))[0] || {}
              if (empresa.mailConfig || empresa.nodemailerConfig) {
                let m = empresa.mailConfig || empresa.nodemailerConfig
                mailConfig = {
                  host: m.host,
                  port: m.port,
                  secure: true, //(this.empresa.emailSecure && this.empresa.emailSecure == 'si') ? true : false,
                  auth: {
                    type: 'basic',
                    user: m.user,
                    pass: m.pw
                  }
                }
              }
              console.log("Emailer Recuperando config default", mailconfig)
            }
            try {
              let objEmail = {
                emailDestino: params.destino,
                emailOrigen: emailOrigen,
                nombreOrigen: nombreOrigen,
                mensaje: mensaje,
                titulo: params.titulo || null,
                mailconfig,
              }
              if (params.attachments && params.attachments.length > 0) {
                objEmail.attachments = params.attachments
              }
              Api.email(objEmail).then(s => {
                resolve(s)
              }, e => {
                reject(e)
                console.error("No se pudo completar el envío del correo")
              })
            } catch (e) {
              console.error("No se pudo enviar el correo")
              reject({
                error: "No se pudo enviar el correo",
                detalles: e
              })
            }
          }
        })
    }
  },
  created() {
    console.log("Emailer montado. Modo pruebas:", this.prueba)
  }
})
export default Emailer
</script>
